// extracted by mini-css-extract-plugin
export default {"menu":"style_menu__7Z0wq","icon":"style_icon__LV9bD","navigation":"style_navigation__HdQWq","title":"style_title__gVAmY"};